import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	timeStamp: null,

	loading: false,
	mapLoading: false,
	createFloorLoading: false,
	updateFloorLoading: false,
	deleteFloorLoading: false,
	floorsLoadingComplete: false,

	error: null,

	searchable: true,
	
	// Floor plan alert state
	floorPlanAlert: {
		visible: true 
	}
};

const floorsSlice = createSlice({
	name: 'floors',
	initialState,
	reducers: {
		loadFloors: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadFloorsSuccess: (state, action) => {
			state.timeStamp = Date.now();
			state.loading = false;

			const orgID = action.payload.orgID;
			const oldFloorsData = state.data[orgID] || [];

			// Merge floors data using 'floorID' as the unique identifier
			state.data[orgID] = mergeReduxStateData(oldFloorsData, action.payload.data, 'floorID');

			state.floorsLoadingComplete = true;
		},
		loadFloorsError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		loadFloorMap: (state) => {
			state.mapLoading = true;
			state.error = null;
		},
		loadFloorMapSuccess: (state, action) => {
			state.mapLoading = false;
			state.data[action.payload.orgID] = state.data[action.payload.orgID].map((floor) =>
				floor.floorID === action.payload.floorID
					? { ...floor, map: { data: action.payload.data, timeStamp: Date.now() } }
					: floor
			);
		},
		loadFloorMapError: (state, action) => {
			state.mapLoading = false;
			state.error = action.payload;
		},
		createFloor: (state) => {
			state.createFloorLoading = true;
			state.error = null;
		},
		createFloorSuccess: (state) => {
			state.createFloorLoading = false;
		},
		createFloorError: (state, action) => {
			state.createFloorLoading = false;
			state.error = action.payload;
		},
		updateFloor: (state) => {
			state.updateFloorLoading = true;
			state.error = null;
		},
		updateFloorSuccess: (state) => {
			state.updateFloorLoading = false;
		},
		updateFloorError: (state, action) => {
			state.updateFloorLoading = false;
			state.error = action.payload;
		},
		deleteFloor: (state) => {
			state.deleteFloorLoading = true;
			state.error = null;
		},
		deleteFloorSuccess: (state) => {
			state.deleteFloorLoading = false;
		},
		deleteFloorError: (state, action) => {
			state.deleteFloorLoading = false;
			state.error = action.payload;
		},
		// Floor Plan Alert actions
		hideFloorPlanAlert: (state) => {
			state.floorPlanAlert.visible = false;
		},
		showFloorPlanAlert: (state) => {
			state.floorPlanAlert.visible = true;
		},
		toggleFloorPlanAlert: (state) => {
			state.floorPlanAlert.visible = !state.floorPlanAlert.visible;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => {
			return initialState; // Reset state on logout
		});
	}
});

// Export the actions
export const floorsActions = floorsSlice.actions;

// Export the reducer
export default floorsSlice.reducer;
